import config from '../config';
import axios from 'axios';

interface EntityLinkParams {
  entityId?: string;
  invitationId?: string;
}

const checkExistingRelationship = async (
  userId: string,
  email: string,
  params: EntityLinkParams
): Promise<{
  data: { alreadyLinked: boolean; entityName: string | null } | null;
  error: string | null;
}> => {
  try {
    const response = await axios.post(
      `${config.NODE_API_BASE_URL}/wso2/registration/check-existing-relationship`,
      { userId, email, ...params }
    );
    return { data: response.data, error: null };
  } catch (error: any) {
    return {
      data: null,
      error: error?.response?.data?.msg || "Something went wrong.",
    };
  }
};

const linkEntity = async (
  userId: string,
  email: string,
  otp: string,
  params: EntityLinkParams
): Promise<{
  data: { profile: any } | null;
  error: string | null;
  code?: string;
}> => {
  try {
    const response = await axios.post(
      `${config.NODE_API_BASE_URL}/wso2/registration/link-entity`,
      { userId, email, otp, ...params }
    );
    return { data: response.data, error: null };
  } catch (error: any) {
    return {
      data: null,
      error: error?.response?.data?.msg || "Something went wrong.",
      code: error?.response?.data?.code,
    };
  }
};

export { checkExistingRelationship, linkEntity };
